import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useSnackbar } from "notistack";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import moment from "moment";
import {
  add_program_workout_api,
  update_program_workout_api,
} from "src/DAL/programmeWorkout/programmeWorkout";
import WorkoutExercisesUI from "./WorkoutExercisesUI";
import WorkoutExercisesAnswerUI from "./WorkoutExercisesAnswerUI";
import { get_root_value } from "src/utils/domUtils";
import {
  exercise_obj,
  extra_workout_exercise,
  formatExercises,
  formatSubExercises,
  generateExerciseArray,
  handleScrollCalled,
  paceFromVdot,
} from "src/utils/constants";
import FoodMattersAndMindsetUI from "./FoodMattersAndMindsetUI";
import { memberRewardDetail } from "src/DAL/Profile/Profile";
import VideoUI from "./VideoUI";
import { s3baseUrl } from "src/config/config";
import WorkoutCalendervideoModel from "./component/WorkoutCalendervideoModel";
import UpdateQueList from "./component/UpdateQueList,";
import GrButton from "src/design-system/components/GrButton";
import GrIcon from "src/design-system/components/GrIcon";
import icons from "src/design-system/icons";
import GrLoader from "src/design-system/components/GrLoader";
import { gr } from "src/design-system/tokens";

const findPaceObjectByVdot = (vdotValue) => {
  return paceFromVdot.find((paceObject) => paceObject.vdot == vdotValue);
};

// Title row of the popup: title | video | close; on phones title | close, the video under them.
const titleRowSx = {
  display: "grid",
  alignItems: "start",
  columnGap: gr.space[4],
  rowGap: gr.space[3],
  mb: gr.space[5],
  gridTemplateColumns: { xs: "minmax(0, 1fr) auto", sm: "minmax(0, 1fr) auto auto" },
  gridTemplateAreas: {
    xs: '"title close" "thumb thumb"',
    sm: '"title thumb close"',
  },
};

// Workout video thumbnail at the top right of the popup (16:9, play button in the middle).
const videoThumbSx = {
  position: "relative",
  display: "block",
  width: { xs: "100%", sm: 200 },
  maxWidth: { xs: 320, sm: 200 },
  aspectRatio: "16 / 9",
  p: 0,
  border: `1px solid ${gr.color.line}`,
  borderRadius: gr.radius.tile,
  overflow: "hidden",
  background: gr.color.brandSoft,
  cursor: "pointer",
  "&:focus-visible": { outline: "none", boxShadow: gr.shadow.focus },
  "& .video-thumb-play": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: gr.control.md,
    height: gr.control.md,
    display: "grid",
    placeItems: "center",
    borderRadius: gr.radius.pill,
    background: gr.color.overlay,
    color: gr.color.onBrand,
    transition: "transform .15s ease",
    "& svg": { width: gr.icon.xl, height: gr.icon.xl },
  },
  "&:hover .video-thumb-play": { transform: "translate(-50%, -50%) scale(1.08)" },
};

const AddWorkoutCalender = forwardRef((props, ref) => {
  const vdot33Object = findPaceObjectByVdot(
    props?.member_vdot ? props?.member_vdot : null,
  );
  const [practiceType, setPracticeType] = useState(props.practice_type);
  const [coinpracticeType, setCoinPracticeType] = useState(props.practice_type);
  const [isNotOpen, setIsNotOpen] = useState(true);
  const [isWorkoutCompleted, setIsWorkoutCompleted] = useState(false);
  const [comment, setCommnet] = useState("");
  const [adminComment, setAdminCommnet] = useState("");
  const [oldImage, setOldImage] = useState();
  const [addArray, setaddArray] = useState([{ ...exercise_obj() }]);
  const [original, setOrignial] = useState();
  const [addArrayExtra, setaddArrayExtra] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [workoutTitle, setWorkoutTitle] = useState("");
  const [complateWorkBook, setComplateWorkBook] = useState(false);
  const [memberRewardData, setMemberRewardData] = useState({});
  const [workoutDescription, setWorkoutDescription] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [inputs, setInputs] = useState({
    video_url: "",
    image: "",
    is_completed: false,
  });

  const handleAdd = () => {
    props.setModalChangeExe(true);
    let list = addArrayExtra;
    list.splice(addArrayExtra.length, 0, {
      ...extra_workout_exercise,
    });
    setaddArrayExtra([...list]);
  };

  useImperativeHandle(ref, () => ({
    childButtonClick() {
      handleSubmit();
    },
    childButtonClick2() {
      handleSubmit().then((formDataObject) => {
        if (formDataObject) props.setWorkoutAsTem(formDataObject);
      });
    },
    childButtonClickUpdate() {
      handleSubmitUpdate();
    },
  }));

  function handleOnDragEnd(result) {
    const items = Array.from(addArray);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setaddArray(items);
  }

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setIsLoading(true);
    props.setIsLoading(true);

    const fullArray = [...addArray, ...addArrayExtra];
    const { exerciesArray, isError } =
      practiceType === "video" || practiceType === "workbook"
        ? { exerciesArray: [], isError: false }
        : generateExerciseArray(fullArray, enqueueSnackbar, true);

    if (isError) {
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }
    const formDataObject = {
      title: workoutTitle,
      workout_type: null,
      description: workoutDescription,
      status: true,
      exercises: exerciesArray,
      program_id: props.programme?._id,
      workout_day: props.day ? props?.day : 1,
      workout_date: moment(props.date).format("YYYY-MM-DD"),
      comment: comment,
      practice_type: practiceType,
    };

    if (practiceType == "food") {
      formDataObject.meals = props?.editData?.meals || [];
      formDataObject.target_day = props?.editData?.target_day || "";
    }

    const result = await add_program_workout_api(formDataObject);
    if (result.code === 200) {
      props?.reloadList();
      setIsLoading(false);
      props.setIsLoading(false);
      props.setOpen(false);
      enqueueSnackbar(result.message, { variant: "success" });
      return formDataObject;
    } else {
      setIsLoading(false);
      props.setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleSubmitUpdate = async (e, value_data) => {
    if (!e) setIsLoading(true);
    props.setIsLoading(true);

    let fullArray = [...addArray, ...addArrayExtra];

    const { exerciesArray, isError } =
      practiceType === "video" || practiceType === "workbook"
        ? { exerciesArray: [], isError: false }
        : generateExerciseArray(fullArray, enqueueSnackbar, true);

    if (isError) {
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    const formDataObject = {
      _id: props?.editData?._id,
      exercises: exerciesArray,
      comment: comment,
      library_type: props?.editData?.library_type,
      questions: props?.questionsToSend,
      workout_date: moment(props?.editData?.workout_date).format("YYYY-MM-DD"),
      type: practiceType == "video" ? "video" : "general",
      practice_type: practiceType,
      program_id: props?.editData?.program_info?.program_id,
      is_completed: value_data ? value_data : inputs?.is_completed,
      video_url: inputs.video_url,
      workbook_completed: value_data ? value_data : complateWorkBook,
      video_thumbnail: inputs.image,
      ...(props.editData?.video_only_type &&
        props.editData?.video_only_type.length > 0 && {
          video_only_type: JSON.stringify(props.editData.video_only_type),
        }),
    };

    if (practiceType == "food") {
      formDataObject.meals = props?.editData?.meals || [];
      formDataObject.target_day = props?.editData?.target_day || "";
    }

    const result = await update_program_workout_api(formDataObject);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      props.setModalChangeExe(false);
      props?.setEditWorkputData(result?.workout);
      const workout = result?.workout;
      let newData = {
        ...workout,
        title: workout.title ? workout.title : "",
        color: workout.program_info?.color,
        workout_color: workout.program_info?.color,
        workout_title: workout.title ? workout.title : "",
        workout_exercises: workout.exercises,
        workout_program: workout.program_info,
        workout_completed: workout.workout_completed,
        status: workout.status,
        date: moment(workout.workout_date).format("YYYY-MM-DD"),
        index: props?.editData?.index,
        open: true,
        editable: false,
      };

      let updatedEvents;
      if (props.editData.workout_id) {
        updatedEvents = props.events.map((event) => {
          if (event.workout_id) {
            if (event.workout_id === props.editData.workout_id) {
              return newData;
            }
          }
          return event;
        });
      } else {
        updatedEvents = props.events.map((event) => {
          if (event._id) {
            if (event._id === props.editData._id) {
              return newData;
            }
          }
          return event;
        });
      }
      let list = [...props?.events];

      list[props?.editData?.index] = newData;
      props?.setEvents(updatedEvents);
      handleScrollCalled(workout?._id);

      setIsLoading(false);
      props.setIsLoading(false);
      return formDataObject;
    } else {
      setIsLoading(false);
      props.setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const getMemberRewardDetail = async () => {
    const result = await memberRewardDetail();
    if (result.code === 200) {
      setMemberRewardData(result?.reward_points);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getMemberRewardDetail();
  }, []);

  useEffect(() => {
    if (props?.editData && isNotOpen) {
      setIsWorkoutCompleted(props?.editData?.workout_completed);
      setComplateWorkBook(props?.editData?.workout_completed);
      setOldImage(props?.editData?.video_thumbnail?.thumbnail_1);
      setInputs({
        ...inputs,
        ["video_url"]: props?.editData?.video_url,
        ["is_completed"]: props?.editData?.is_completed,
        ["image"]: props?.editData?.video_thumbnail,
      });
      setCoinPracticeType(
        props?.editData?.program_info?.program_type == "video"
          ? "program_video"
          : props?.editData?.practice_type
          ? props?.editData?.practice_type
          : "workout",
      );
      setPracticeType(
        props?.editData?.practice_type
          ? props?.editData?.practice_type
          : "workout",
      );
      setWorkoutTitle(
        props?.editData?.workout_title
          ? props?.editData?.workout_title
          : props?.editData?.title,
      );
      setWorkoutDescription(props?.editData?.description);
      setCommnet(props?.editData?.comment);
      setAdminCommnet(props?.editData?.admin_comment);

      const givenExercise = formatExercises(
        props?.editData?.exercises,
        props?.member_vdot,
        vdot33Object,
      );

      const givenExerciseExtra = formatSubExercises(
        props?.editData?.exercises,
        true,
        props?.member_vdot,
        vdot33Object,
      );

      setaddArray(givenExercise);
      setOrignial(JSON.parse(JSON.stringify(givenExercise)));
      setaddArrayExtra(givenExerciseExtra);
      setIsNotOpen(false);
    }
  }, [props?.editData]);

  if (isLoading === true) {
    return (
      <>
        {props.closeButton ? (
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>{props.closeButton}</Box>
        ) : null}
        <GrLoader sx={{ py: gr.space[12] }} />
      </>
    );
  }

  return (
    <div className="container-fluid">
      {modalOpen && (
        <WorkoutCalendervideoModel
          onOpen={modalOpen}
          setOnOpen={setModalOpen}
          url={inputs?.video_url}
        />
      )}
      <div className=" ">
        {/* Title row: title + description | video thumbnail | close (phones: the video under the title). */}
        <Box sx={titleRowSx}>
          <Box sx={{ gridArea: "title", minWidth: 0 }}>
            <Box
              component="h2"
              sx={{
                m: 0,
                fontFamily: gr.font.family,
                fontSize: gr.font.size.h2,
                fontWeight: gr.font.weight.medium,
                lineHeight: gr.font.lineHeight.tight,
                color: gr.color.brandStrong,
              }}
            >
              {workoutTitle}
            </Box>
            {workoutDescription && (
              <Box
                component="p"
                sx={{
                  m: `${gr.space[2]} 0 0`,
                  fontFamily: gr.font.family,
                  fontSize: gr.font.size.md,
                  lineHeight: gr.font.lineHeight.normal,
                  color: gr.color.ink2,
                  whiteSpace: "pre-line",
                }}
              >
                {workoutDescription}
              </Box>
            )}
          </Box>
          <Box sx={{ gridArea: "thumb", minWidth: 0 }}>
            {/* The workout's video: a 16:9 thumbnail with a play button (opens the video). If the
                picture does not load, a soft tile with the play button stays. */}
            {practiceType != "video" && oldImage ? (
              <Box
                component="button"
                type="button"
                aria-label="Play video"
                onClick={() => {
                  setModalOpen(true);
                }}
                sx={videoThumbSx}
              >
                <Box
                  component="img"
                  src={s3baseUrl + oldImage}
                  alt=""
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.style.visibility = "hidden";
                  }}
                  sx={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
                <Box component="span" className="video-thumb-play" aria-hidden="true">
                  <GrIcon icon={icons.playArrow} />
                </Box>
              </Box>
            ) : null}
          </Box>
          {props.closeButton ? (
            <Box sx={{ gridArea: "close" }}>{props.closeButton}</Box>
          ) : null}
        </Box>
        <DragDropContext
          onDragEnd={handleOnDragEnd}
          className="h-100"
          isDragDisabled={true}
        >
          <Droppable droppableId="characters" isDragDisabled={true}>
            {(provided) => (
              <div
                className="characters"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {practiceType == "workout" ? (
                  <WorkoutExercisesAnswerUI
                    addArray={addArray}
                    setaddArray={setaddArray}
                    setModalChangeExe={props.setModalChangeExe}
                    original={original}
                    practiceType={coinpracticeType}
                    isWorkoutCompleted={isWorkoutCompleted}
                    setIsWorkoutCompleted={setIsWorkoutCompleted}
                    memberRewardData={memberRewardData}
                    handleSubmit={handleSubmitUpdate}
                    member_vdot={props?.member_vdot}
                  />
                ) : practiceType == "video" || practiceType == "comment" ? (
                  <VideoUI
                    inputs={inputs}
                    setInputs={setInputs}
                    setModalChangeExe={props.setModalChangeExe}
                    setIsWorkoutCompleted={setIsWorkoutCompleted}
                    practiceType={coinpracticeType}
                    handleSubmit={handleSubmitUpdate}
                    comment_data={props}
                  />
                ) : practiceType == "workbook" ? (
                  <UpdateQueList
                    questions={props.questionsToSend}
                    setQuestions={props.setQuestionsToSend}
                    editShow={props.editShow}
                    setEditShow={props.setEditShow}
                    mainindex={0}
                    complateWorkBook={complateWorkBook}
                    setComplateWorkBook={setComplateWorkBook}
                    setModalChangeExe={props.setModalChangeExe}
                    practiceType={coinpracticeType}
                    isWorkoutCompleted={isWorkoutCompleted}
                    handleSubmit={handleSubmitUpdate}
                  />
                ) : (
                  <FoodMattersAndMindsetUI
                    addArray={addArray}
                    setaddArray={setaddArray}
                    setModalChangeExe={props.setModalChangeExe}
                    mainindex={0}
                    isWorkoutCompleted={isWorkoutCompleted}
                    setIsWorkoutCompleted={setIsWorkoutCompleted}
                    practiceType={coinpracticeType}
                    memberRewardData={memberRewardData}
                    handleSubmit={handleSubmitUpdate}
                    meals_data={props}
                  />
                )}
                {addArrayExtra.length > 0 && (
                  <>
                    <Box sx={{ margin: `${gr.space[6]} 0 ${gr.space[3]}` }}>
                      <Box
                        component="h3"
                        sx={{
                          m: 0,
                          display: "flex",
                          alignItems: "center",
                          gap: gr.space[2],
                          fontFamily: gr.font.family,
                          fontSize: gr.font.size.lg,
                          fontWeight: gr.font.weight.semibold,
                          color: gr.color.ink,
                        }}
                      >
                        <Box component="span" sx={{ display: "inline-flex", color: gr.color.brand }}>
                          <GrIcon icon={icons.energy} />
                        </Box>
                        Extra work
                      </Box>
                      <Box sx={{ mt: gr.space[1], fontSize: gr.font.size.sm, color: gr.color.muted }}>
                        These exercises aren’t part of the original workout
                      </Box>
                    </Box>
                    <WorkoutExercisesUI
                      addArray={addArrayExtra}
                      setaddArray={setaddArrayExtra}
                      setModalChangeExe={props.setModalChangeExe}
                      memberRewardData={memberRewardData}
                    />
                  </>
                )}
                {practiceType == "workout" && (
                  <Box sx={{ margin: `${gr.space[4]} 0` }}>
                    <GrButton
                      variant="secondary"
                      size="sm"
                      startIcon={<GrIcon icon={icons.plus} size="sm" />}
                      onClick={() => {
                        handleAdd();
                      }}
                    >
                      Add extra work
                    </GrButton>
                  </Box>
                )}
                {practiceType !== "comment" && (
                  <>
                    {adminComment ? (
                      <div className="container-fluid">
                        <div
                          className=" my-3"
                          style={{
                            whiteSpace: "break-spaces",
                            fontSize: 14,
                            opacity: 0.7,
                            color: "black",
                          }}
                        >
                          <span
                            style={{
                              opacity: 1,
                              fontWeight: "bold",
                              display: "block",
                              color: get_root_value("--portal-theme-primary"),
                            }}
                          >
                            Comment
                          </span>
                          <div className="ms-0">{comment}</div>
                        </div>
                      </div>
                    ) : (
                      <div className=" my-2">
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder="Add Comment here!"
                          label="Comment"
                          type="number"
                          value={comment}
                          name="description"
                          multiline
                          minRows={3}
                          onChange={(e) => setCommnet(e.target.value)}
                          InputLabelProps={{
                            shrink: true,
                            style: { fontSize: "14px" },
                          }}
                          InputProps={{
                            style: { fontSize: "14px" },
                            readOnly: adminComment,
                          }}
                          sx={{
                            borderRadius: "5px",
                            mt: 2,
                            width: "100%",
                          }}
                        />
                      </div>
                    )}
                    {adminComment && (
                      <div className="container-fluid">
                        <div
                          className=" my-3"
                          style={{
                            whiteSpace: "break-spaces",
                            fontSize: 14,
                            opacity: 0.7,
                            color: "black",
                          }}
                        >
                          <span
                            style={{
                              opacity: 1,
                              fontWeight: "bold",
                              display: "block",
                              color: get_root_value("--portal-theme-primary"),
                            }}
                          >
                            Reply
                          </span>
                          <div className="ms-0">{adminComment}</div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
});
export default AddWorkoutCalender;
